/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({ name: 'safe' })
export class SafeUrlPipe implements PipeTransform {
	constructor(private sanitizer: DomSanitizer) {}
	public transform(url) {
		return this.sanitizer.bypassSecurityTrustResourceUrl(url);
	}
}
